import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
import { Label } from 'reactstrap';
import SegmentedPickerButton from './segmentedPickerButton';
const SegmentedPicker = _ref => {
  let onChange = _ref.onChange,
    _ref$value = _ref.value,
    propsValue = _ref$value === void 0 ? null : _ref$value,
    _ref$allowNull = _ref.allowNull,
    allowNull = _ref$allowNull === void 0 ? true : _ref$allowNull,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? [] : _ref$values,
    names = _ref.names,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '\u00a0' : _ref$label,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  const handleClick = value => {
    let newValue;
    if (allowNull) {
      // If the value is currently set, toggle it to null
      newValue = value === propsValue ? null : value;
    } else if (propsValue !== value) {
      newValue = value;
    }

    // Only update the value if it actually changed
    if (typeof newValue !== 'undefined') {
      onChange(newValue);
    }
  };
  const buttons = names.map((name, index) => {
    let value;
    if (values && values.length === names.length) {
      value = values[index];
    } else {
      value = index;
    }
    const classes = classnames({
      active: propsValue === value,
      leftButton: index === 0,
      rightButton: index === names.length - 1,
      middleButton: index !== 0 && index !== names.length - 1,
      'form-control': true,
      ["t-sp-button t-sp-".concat(kebabCase(name))]: true,
      'tqc-control': true
    });
    const width = 100 / names.length;
    return /*#__PURE__*/React.createElement(SegmentedPickerButton, {
      className: classes,
      key: name,
      isDisabled: isDisabled,
      onClick: handleClick,
      value: value,
      width: width
    }, name);
  });
  const classNames = kebabCase(className.length > 0 ? className : "t-dtp-".concat(label));
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(classNames)
  }, hideLabel ? null : /*#__PURE__*/React.createElement(Label, {
    className: "text-input-custom-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "s-sp ".concat(classNames)
  }, buttons));
};
SegmentedPicker.propTypes = {
  className: PropTypes.string,
  allowNull: PropTypes.bool,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])),
  isDisabled: PropTypes.bool
};
export default SegmentedPicker;